import GroupJoin from './GroupJoin'

export default [
    {
        path: '/join/:group_hash',
        component: GroupJoin,
        name: 'groupJoin'
    }
]
